import { Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import {Clientnummer, ClientZoekMethode} from './clientnummer';
import {NotificationService} from '../../core/notification/notification.service';
import {ClientnummerQrScanComponent} from './qr/clientnummer-qr-scan.component';
import {ThemePalette} from '@angular/material/core';

@Component({
    selector: 'zah-clientnummer-selector',
    templateUrl: './clientnummer-selector.component.html',
    styleUrls: ['./clientnummer-selector.component.scss'],
    standalone: false
})
export class ClientnummerSelectorComponent {
    private notificationService = inject(NotificationService);

    @Input()
    actieLabel: string;
    @Input()
    actiePalette: ThemePalette = 'accent';
    @Output()
    clientnummerSelected: EventEmitter<Clientnummer> = new EventEmitter<Clientnummer>();

    @ViewChild(ClientnummerQrScanComponent)
    private qrScanComponent: ClientnummerQrScanComponent;
    private qrCodeMode = true;

    isNummerMode(): boolean {
        return !this.qrCodeMode;
    }

    searchOnNummer(): void {
        this.qrScanComponent.disableQrScanner();
        this.qrCodeMode = false;
    }

    isQrCodeMode(): boolean {
        return this.qrCodeMode;
    }

    searchOnQrCode(): void {
        this.qrCodeMode = true;
        this.qrScanComponent.enableQrScanner();
    }

    isQrScannerEnabled(): boolean {
        return this.qrScanComponent && this.qrScanComponent.isQrScannerEnabled();
    }

    onScanSuccess(clientnummer: string): void {
        this.clientnummerSelected.next(new Clientnummer(clientnummer, ClientZoekMethode.QR_CODE));
    }

    onNummerInput(clientnummer: string): void {
        this.clientnummerSelected.next(new Clientnummer(clientnummer, ClientZoekMethode.NUMMER));
    }

    onScanError(): void {
        this.notificationService.showWarning('Deze QR code kan niet goed gelezen worden. Zoek je cliënt op met het cliëntnummer.');
    }

    onNoCamerasFound(): void {
        this.notificationService.showWarning('Er werden geen camera\'s gevonden op je toestel. Zoek je cliënt op met het cliëntnummer.');
    }

    onNoCameraPermission(): void {
        this.notificationService.showWarning('Geef Zorg@HOME toestemming om je camera te gebruiken. ' +
            'Of ga verder door op cliëntnummer te zoeken');
    }
}
